import { render, staticRenderFns } from "./sendPushModal.vue?vue&type=template&id=d27345ce&"
import script from "./sendPushModal.vue?vue&type=script&lang=ts&"
export * from "./sendPushModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports